import { render, staticRenderFns } from "./videoPlay.vue?vue&type=template&id=4cda6536&scoped=true"
import script from "./videoPlay.vue?vue&type=script&lang=js"
export * from "./videoPlay.vue?vue&type=script&lang=js"
import style0 from "./videoPlay.vue?vue&type=style&index=0&id=4cda6536&prod&lang=less&scoped=true"
import style1 from "./videoPlay.vue?vue&type=style&index=1&id=4cda6536&prod&lang=less"
import style2 from "./videoPlay.vue?vue&type=style&index=2&id=4cda6536&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cda6536",
  null
  
)

export default component.exports